import React from 'react';
import { IconsPros } from './types';

/**
 * Contents Icon component
 *
 * @returns JSX.ELEMENT
 */
export const ContentsIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M15.18,14.19H5.61c-.64,0-1.14.69-1.14,1.57s.5,1.57,1.14,1.57h9.57c.64,0,1.14-.69,1.14-1.57S15.75,14.19,15.18,14.19Zm0-9.72c.64,0,1.14-.69,1.14-1.57s-.5-1.57-1.14-1.57H1.48C.83,1.33.33,2,.33,2.9s.5,1.57,1.14,1.57Zm0,3.31H5.61c-.64,0-1.14.69-1.14,1.57s.5,1.57,1.14,1.57h9.57c.64,0,1.14-.69,1.14-1.57S15.75,7.79,15.18,7.79Z" />
    </svg>
  );
};
